<template>
  <div class="max-w-lg m-auto">
    Page not found
  </div>
</template>

<script>

  export default {
    
   //  methods : {

			// postTypeSelected(postType) {
			// 	this.$router.push('/submit/' + postType + '/-1')
			// }
   //  },

    // created() {
    //   console.log("hhh")
    // }

  }
</script>